import { Image as ImageLib } from 'react-native';

const COMPRESS_RATIO = 0.85;
const MAX_WIDTH = 1280;

export async function compress(uri: string) {
	const { width } = await getDimensions(uri);
	const shouldBeResized = width > MAX_WIDTH;

	const manipulate = await import('expo-image-manipulator').then((imported) =>
		imported.ImageManipulator.manipulate(uri),
	);

	const manipulateContext = shouldBeResized
		? manipulate.resize({
				width: shouldBeResized ? MAX_WIDTH : null,
			})
		: manipulate;

	return (await manipulateContext.renderAsync()).saveAsync({
		compress: COMPRESS_RATIO,
	});
}

function getDimensions(uri: string): Promise<{ width: number; height: number }> {
	return new Promise((resolve, reject) => {
		ImageLib.getSize(uri, (width, height) => resolve({ width, height }), reject);
	});
}
